module.exports = __webpack_public_path__ + "static/img/logoMin.4c91166.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoMin.png
// module id = XCfP
// module chunks = 9